import styled from "styled-components";

export const ContainerAction = styled.div`
  display: flex;
  flex-direction: row;
`;

